export async function getThemeAndColor(organizationConfig, overriddenTheme) {
  const { theme = {} } = organizationConfig
  const name = 'Quick' || theme.name
  switch (name) {
    // case 'Fashion': {
    //   const { defaultTheme } = await import('../themes/fashion/theme')
    //   return {
    //     websiteTheme: 'Fashion',
    //     style: defaultTheme,
    //     currentTheme: 'Fashion',
    //   }
    // }
    // case 'Elegance': {
    //   const { defaultTheme } = await import('../themes/elegance/theme')
    //   return {
    //     websiteTheme: 'Elegance',
    //     style: defaultTheme,
    //     currentTheme: 'Elegance',
    //   }
    // }
    // case 'Trendsetter': {
    //   const { defaultTheme } = await import('../themes/trendsetter/theme')
    //   return {
    //     websiteTheme: 'Trendsetter',
    //     style: defaultTheme,
    //     currentTheme: 'Trendsetter',
    //   }
    // }
    // case 'MediCore': {
    //   const { mediCoreTheme } = await import('../themes/medicore/theme')
    //   return {
    //     websiteTheme: 'MediCore',
    //     style: mediCoreTheme,
    //     currentTheme: 'MediCore',
    //   }
    // }
    // case 'ScanSure': {
    //   const { scanSureTheme } = await import('../themes/scansure/theme')
    //   return {
    //     websiteTheme: 'ScanSure',
    //     style: scanSureTheme,
    //     currentTheme: 'ScanSure',
    //   }
    // }
    // case 'Lifestyle': {
    //   const { defaultTheme } = await import('../themes/lifestyle/theme')
    //   return {
    //     websiteTheme: 'Lifestyle',
    //     style: defaultTheme,
    //     currentTheme: 'Lifestyle',
    //   }
    // }
    // case 'Personal-care': {
    //   const { defaultTheme } = await import('../themes/personal/theme')
    //   return {
    //     websiteTheme: 'Personal-care',
    //     style: defaultTheme,
    //     currentTheme: 'Personal-care',
    //   }
    // }
    // case 'Sports': {
    //   const { defaultTheme } = await import('../themes/sports/theme')
    //   return {
    //     websiteTheme: 'Sports',
    //     style: defaultTheme,
    //     currentTheme: 'Sports',
    //   }
    // }
    // case 'Beauty': {
    //   const { beautyTheme } = await import('../themes/beauty/theme')
    //   return {
    //     websiteTheme: 'Beauty',
    //     style: beautyTheme,
    //     currentTheme: 'Beauty',
    //   }
    // }
    // case 'Gifts': {
    //   const { defaultTheme } = await import('../themes/gifts/theme')
    //   return {
    //     websiteTheme: 'Gifts',
    //     style: defaultTheme,
    //     currentTheme: 'Gifts',
    //   }
    // }
    // case 'Moonshot': {
    //   const { moonshotTheme } = await import('../themes/moonshot/theme')
    //   return {
    //     websiteTheme: 'Moonshot',
    //     style: moonshotTheme,
    //     currentTheme: 'Moonshot',
    //   }
    // }
    // case 'Single': {
    //   const { defaultTheme } = await import('../themes/titan/theme')
    //   return {
    //     websiteTheme: 'Titan',
    //     style: defaultTheme,
    //     currentTheme: 'Titan',
    //   }
    // }
    // case 'Darknight': {
    //   const { darknightTheme } = await import('../themes/darknight/theme')
    //   return {
    //     websiteTheme: 'Darknight',
    //     style: darknightTheme,
    //     currentTheme: 'Darknight',
    //   }
    // }
    case 'Default Theme': {
      const { defaultTheme } = await import('../themes/default/theme')
      return {
        websiteTheme: 'Default-Theme',
        style: defaultTheme,
        currentTheme: 'Default Theme',
      }
    }
    // case 'Zopnow': {
    //   const { defaultTheme } = await import('../themes/zopnow/theme')
    //   return {
    //     websiteTheme: 'Zopnow',
    //     style: defaultTheme,
    //     currentTheme: 'Zopnow',
    //   }
    // }
    // case 'Ruby': {
    //   const { redTheme } = await import('../themes/default/theme')
    //   return {
    //     websiteTheme: 'Default-Theme',
    //     style: redTheme,
    //     currentTheme: 'Ruby',
    //   }
    // }
    // case 'WSI': {
    //   const { wsiTheme } = await import('../themes/default/theme')
    //   return {
    //     websiteTheme: 'Default-Theme',
    //     style: wsiTheme,
    //     currentTheme: 'theme-wsi',
    //   }
    // }
    // case 'Blaze': {
    //   const { blazeTheme } = await import('../themes/moonshot/theme')
    //   return {
    //     websiteTheme: 'Moonshot',
    //     style: blazeTheme,
    //     currentTheme: 'Blaze',
    //   }
    // }
    // case 'Emerald': {
    //   const { greenTheme } = await import('../themes/default/theme')
    //   return {
    //     websiteTheme: 'Default-Theme',
    //     style: greenTheme,
    //     currentTheme: 'Emerald',
    //   }
    // }
    // case 'Yellow': {
    //   const { yellowTheme } = await import('../themes/default/theme')
    //   return {
    //     websiteTheme: 'Default-Theme',
    //     style: yellowTheme,
    //     currentTheme: 'Yellow',
    //   }
    // }
    // case 'Sapphire': {
    //   const { sapphireTheme } = await import('../themes/default/theme')
    //   return {
    //     websiteTheme: 'Default-Theme',
    //     style: sapphireTheme,
    //     currentTheme: 'Sapphire',
    //   }
    // }
    // case 'Pharma': {
    //   const { defaultTheme } = await import('../themes/pharma/theme')
    //   return {
    //     websiteTheme: 'Pharma',
    //     style: defaultTheme,
    //     currentTheme: 'Pharma',
    //   }
    // }
    // case 'White': {
    //   const { whiteTheme } = await import('../themes/zopnow/theme')
    //   return {
    //     websiteTheme: 'Zopnow',
    //     style: whiteTheme,
    //     currentTheme: 'White',
    //   }
    // }
    // case 'Getz': {
    //   const { getzTheme } = await import('../themes/getz/theme')
    //   return {
    //     websiteTheme: 'Getz',
    //     style: getzTheme,
    //     currentTheme: 'Getz',
    //   }
    // }
    // case 'ZopStore': {
    //   const { zopStore } = await import('../themes/zopstore/theme')
    //   return {
    //     websiteTheme: 'ZopStore',
    //     style: zopStore,
    //     currentTheme: 'ZopStore',
    //   }
    // }
    // case 'Fresh': {
    //   const { freshTheme } = await import('../themes/fresh/theme')
    //   return {
    //     websiteTheme: 'Fresh',
    //     style: freshTheme,
    //     currentTheme: 'Fresh',
    //   }
    // }
    case 'Quick': {
      const { quickTheme } = await import('../themes/quickshop/theme')
      return {
        websiteTheme: 'Quick',
        style: quickTheme,
        currentTheme: 'Quick',
      }
    }
    // case 'HealthNext': {
    //   const { healthNextTheme } = await import('../themes/healthnext/theme')
    //   return {
    //     websiteTheme: 'HealthNext',
    //     style: healthNextTheme,
    //     currentTheme: 'HealthNext',
    //   }
    // }
    // case 'TropiWave': {
    //   const { tropiWaveTheme } = await import('../themes/tropiwave/theme')
    //   return {
    //     websiteTheme: 'TropiWave',
    //     style: tropiWaveTheme,
    //   }
    // }
    // case 'Value': {
    //   const { valueTheme } = await import('../themes/value/theme')
    //   return {
    //     websiteTheme: 'Value',
    //     style: valueTheme,
    //   }
    // }
    // case 'Glide': {
    //   const { defaultTheme } = await import('../themes/glide/theme')
    //   return {
    //     websiteTheme: 'Glide',
    //     style: defaultTheme,
    //   }
    // }
    // case 'InkGlow': {
    //   const { defaultTheme } = await import('../themes/inkglow/theme')
    //   return {
    //     websiteTheme: 'InkGlow',
    //     style: defaultTheme,
    //   }
    // }
    // case 'Bazar': {
    //   const { BazarTheme } = await import('../themes/bazar/theme')
    //   return {
    //     websiteTheme: 'Bazar',
    //     style: BazarTheme,
    //   }
    // }
    default: {
      const { defaultTheme } = await import('../themes/default/theme')
      return {
        websiteTheme: 'Default-Theme',
        style: defaultTheme,
      }
    }
  }
}
